export enum SiteContextBasedIdEnum {
  'dk-b2b' = 'mediqdkb2b',
  'dk-b2c' = 'mediqdkb2c',
  'no-b2b' = 'mediqnob2b',
  'se-b2b' = 'mediqseb2b',
  'fi-b2b' = 'mediqfib2b',
}
